/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'

const entity = {
  name: {
    displayName: 'Name',
  },
  lang: {},
  printName: {
    displayName: 'printName',
    formConfig: {
      required: false,
    },
  },
}
export default IKDataEntity.ModelFactory(entity, {})
